var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 28
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1099",
    transform: "translate(-1416.999 -458)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1070",
    d: "M1446.44 486h-27.007a2.355 2.355 0 01-1.721-.714 2.357 2.357 0 01-.714-1.72v-20.319a2.357 2.357 0 01.714-1.72 2.355 2.355 0 011.721-.714h17.74a4.278 4.278 0 00-.147.944 7.834 7.834 0 00.02.947 7.729 7.729 0 00.63 2.664 7.636 7.636 0 001.468 2.2l-6.206 4.072-12.708-8.312a.779.779 0 00-.432-.144.7.7 0 00-.322.082.829.829 0 00-.462.606.63.63 0 00.063.419 1.364 1.364 0 00.272.38l12.917 8.522a1.271 1.271 0 00.672.21 1.27 1.27 0 00.671-.21l6.878-4.534a6.906 6.906 0 001.95.966 7.486 7.486 0 002.244.334 6.945 6.945 0 002.2-.357 8.11 8.11 0 001.992-.986v14.946a2.357 2.357 0 01-.714 1.72 2.355 2.355 0 01-1.719.718z",
    fill: "#17bed0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1149",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1440 458)",
    fill: "#ff9700"
  }))));
}
export default SvgCheckEmail;